import { Link } from 'react-router-dom';

// Footer 保留原静态站的品牌信息和社交链接；内部页面跳转使用 Link，外部站点使用普通 a。
export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-brand">Evacuate from Meaning</div>
        <div className="footer-links">
          <Link to="/contact">Contact</Link>
          <a href="#shipping">Shipping</a>
          <a href="#privacy">Privacy</a>
        </div>
        <div className="footer-social">
          <a href="https://instagram.com/evacuate.from.meaning" target="_blank" rel="noreferrer">
            Instagram
          </a>
        </div>
      </div>
    </footer>
  );
}
